export const CompanyMenuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        roles:['Company']
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/company/dashboard",
        roles:['Company','Admin']
        
        // badge: {
        //     variant: "info",
        //     text: "menuitems.dashboards.badge"
        // },
        // subItems: [
        //     {
        //         id: 3,
        //         label: "menuitems.dashboards.list.default",
        //         link: "/",
        //         parentId: 2
        //     },
            
        // ]
    }, 
    {
        id: 3,
        label: "menuitems.history.text",
        icon: "bx-news",
        link: "/company/newsfeeds",
        roles:['Company','Admin']
    }, 
    {
        id: 4,
        label: "menuitems.post.text",
        icon: "bx-align-justify",
        link: "/posts",
        roles:['Company','Admin']
    },
    {
        id: 5,
        label: "menuitems.follower.text",
        icon: "bx-user-circle",
        link: "/followers",
        roles:['Company','Admin']
    },
    {
        id: 6,
        label: "menuitems.event.text",
        icon: "bx-notepad",
        link: "/events",
        roles:['Company','Admin']
    },
    {
        id: 7,
        label: "menuitems.finance.text",
        icon: "bx bxs-file",
        link: "/finance/folder/list",
        roles:['Company','Admin']
    },
    {
        id: 8,
        label: "menuitems.publication.text",
        icon: "bx bxs-file",
        link: "/publication/folder/list",
        roles:['Company','Admin']
    },
    {
        id: 9,
        label: "menuitems.governance.text",
        icon: "bx bxs-file",
        link: "/governance/folder/list",
        roles:['Company','Admin']
    },
    {
        id: 10,
        label: "menuitems.notification.text",
        icon: "bx bx-bell",
        link: "/notification",
        roles:['Company','Admin']
    },{
        id: 11,
        label: "menuitems.chat.text",
        icon: "bx-message",
        link: "/chat",
        roles: ["Company","Admin"]
    }, 
];

